import style from './Helper.module.css';

export function HelperContact() {
  return (
    <>
      <section id="contact" className={style.helper}></section>
    </>
  );
}
